import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import { buildQueryString } from '../../../shared';
import type {
  GetEmployeesFilteredParams,
  LC_GetEmployeesFilteredIn,
  LC_GetEmployeesFilteredOut,
  FilteredEmployeesPage,
} from '../types';
import { mapFilteredEmployeesPage } from '../mappers';


function toCSV(ids?: (string | number)[]): string | null {
  return ids && ids.length > 0 ? ids.join(',') : null;
}

// Contrato de wire compartido por todo combo "Colaborador" filtrado dimensionalmente
// (Empleados, Gestor de Marcas, ...): arma el DTO, resuelve contra el endpoint recibido y
// mapea la respuesta. Cada pantalla solo aporta su propio endpoint; el permiso que lo
// autoriza ya lo resuelve el backend según esa ruta.
export async function fetchFilteredEmployeesPage(
  endpoint: string,
  params: GetEmployeesFilteredParams,
  signal?: AbortSignal,
): Promise<ApiResponse<FilteredEmployeesPage>> {
  const dto: LC_GetEmployeesFilteredIn = {
    companyIds: toCSV(params.companyIds),
    areaIds: toCSV(params.areaIds),
    positionIds: toCSV(params.positionIds),
    costCenterIds: toCSV(params.costCenterIds),
    locationIds: toCSV(params.locationIds),
    contractModalityIds: toCSV(params.contractModalityIds),
    groupIds: toCSV(params.groupIds),
    status: params.status ?? null,
    searchText: params.searchText ?? null,
    page: params.page,
    pageSize: params.pageSize,
    employeeIds: toCSV(params.employeeIds),
  };

  const queryString = buildQueryString({ ...dto });
  const response = await apiClient.get<LC_GetEmployeesFilteredOut>(`${endpoint}${queryString}`, { signal });

  if (!response.success || !response.data) {
    return { ...response, data: null };
  }

  return { ...response, data: mapFilteredEmployeesPage(response.data) };
}

export class EmployeeFilteredService {
  async getFiltered(
    params: GetEmployeesFilteredParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<FilteredEmployeesPage>> {
    return fetchFilteredEmployeesPage(API_CONFIG.ENDPOINTS.EMPLOYEES.FILTERED, params, signal);
  }
}

export const employeeFilteredService = new EmployeeFilteredService();
